import { cn } from '@rocco/utils/cn';
import { TAB_CONTENT_GAP } from '../utils/tab-spacing';

/** Anchor id the enquiry CTAs scroll to (the inline enquiry form). */
export const CONTACT_ENQUIRY_ANCHOR = 'professional-contact-enquiry';

/**
 * Contact tab intro (Figma 2193:11058) — the tab's heading, and nothing drawn.
 *
 * The display heading repeated the tab pill above it, and the value stat +
 * Get in touch / Visit Website / Save cluster repeated the profile summary
 * header under the banner, which every tab now carries. What was left was a
 * divider with nothing on either side of it: 88px of blank under the tab
 * strip, then a hairline a finger's width below the strip's own border, then
 * the map. The heading stays for the document outline; the rule and the run
 * of empty page it floated in are gone, and the map opens on the tab's own
 * gap like every other tab's first block.
 */
export const ProfessionalContactConnectSection = () => {
    return (
        <section
            className={cn(
                'w-full overflow-hidden bg-ground text-[#1f1f21] max-md:px-6 md:px-[3.125rem]',
                TAB_CONTENT_GAP,
            )}
        >
            <div className="mx-auto w-full max-w-[113.75rem]">
                {/* The tab pill above names the page; this keeps the tab's
                    heading in the document outline. */}
                <h2 className="sr-only">Let&apos;s connect</h2>
            </div>
        </section>
    );
};
